<template>
  <v-app id="app">
    <div v-if="!this.$route.meta.HideHeader">
      <app-header />
      <app-layout />
    </div>
    <div class="fill-height" v-else>
      <v-content>
        <router-view />
      </v-content>
    </div>
    <app-footer v-if="!this.$route.meta.guest"/>
    <idle-timeout-dialog
      :visible="showIdleDialog"
      @stay="onIdleStay"
      @logout="handleIdleLogout"
    />
  </v-app>
</template>


<script>
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import Layout from "./Layout";
import IdleTimeoutDialog from "./components/common/IdleTimeoutDialog";
import { createIdleTimer } from "./utils/idleTimer";

export default {
  components: {
    "app-header": Header,
    "app-footer": Footer,
    "app-layout": Layout,
    "idle-timeout-dialog": IdleTimeoutDialog,
  },

  data() {
    return {
      showIdleDialog: false,
      idleTimer: null,
      idleTimerConfig: { enabled: true, timeoutMinutes: 15 },
      idleTimerConfigLoaded: false,
    };
  },

  watch: {
    $route() {
      this.syncIdleTimer();
    },
  },

  methods: {
    async syncIdleTimer() {
      const isLoggedIn = typeof this.$session.get("access_token") !== "undefined";
      if (isLoggedIn && !this.$route.meta.guest) {
        if (!this.idleTimer) {
          if (!this.idleTimerConfigLoaded) {
            await this.getIdleTimerConfig();
            this.idleTimerConfigLoaded = true;
          }
          this.idleTimer = createIdleTimer({
            onWarn: () => { this.showIdleDialog = true; },
            onLogout: () => { this.handleIdleLogout(); },
            enabled: this.idleTimerConfig.enabled,
            timeoutMinutes: this.idleTimerConfig.timeoutMinutes,
          });
          this.idleTimer.start();
        }
      } else {
        if (this.idleTimer) {
          this.idleTimer.stop();
          this.idleTimer = null;
        }
        this.idleTimerConfigLoaded = false;
        this.showIdleDialog = false;
      }
    },

    handleIdleLogout() {
      this.showIdleDialog = false;
      const db = this.$store.getters.db;
      this.$store.dispatch("deleteToken");
      window.location.href = `/${this.$i18n.locale}/home/${db}`;
    },

    onIdleStay() {
      this.showIdleDialog = false;
      if (this.idleTimer) this.idleTimer.reset();
    },

    async getApiUrlHandler() {
      // if (process.env.NODE_ENV === "development") {
      //   this.$store.dispatch("retrvDevApi").catch((error) => {
      //     console.log(error);
      //   });
      // } else {
      //   this.$store.dispatch("retrvProdApi").catch((error) => {
      //     console.log(error);
      //   });
      // }
      try {
        if (process.env.NODE_ENV === "development") {
          await this.$store.dispatch("retrvDevApi");
        } else {
          await this.$store.dispatch("retrvProdApi");
        }
      } catch (error) {
        console.log(error);
      }
      this.$root.$emit('api-ready');
    },
    checkislogin() {
      if (typeof this.$session.get("access_token") == "undefined") {
        // this.$store.dispatch("deleteToken");
        // this.$router.replace("/" + this.$i18n.locale + "/login");
      }
    },
    resetTokenHandler() {
      this.$store.dispatch("deleteToken");
    },

    async getFileUploadConfig() {
      // this.$store.dispatch("retriveFileUploadConfig").catch((error) => {
      //   console.log(error);
      // });
      try {
        await this.$store.dispatch("retriveFileUploadConfig");
      } catch (error) {
        console.log(error);
      }
    },

    async getIdleTimerConfig() {
      try {
        const res = await this.$store.dispatch("get", { url: "/idletimerconfig" });
        if (res.data.status === 201) {
          this.idleTimerConfig = res.data.rec;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    await this.getApiUrlHandler();
    await this.getFileUploadConfig();
    // this.checkislogin();
    //this.resetTokenHandler();
    this.syncIdleTimer();
  },

  beforeDestroy() {
    if (this.idleTimer) this.idleTimer.stop();
  },
};
</script>
